import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SessionSelectors } from '@store';
import { IndexCard, InvoiceFilterOptions, InvoiceListPeriod } from '@store/models';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-invoices-options',
    templateUrl: './invoices-options.component.html',
    standalone: false
})
export class InvoicesOptionsComponent implements OnInit, OnDestroy {
    @Input() searchFor = '';
    @Output() filterOptions = new EventEmitter<InvoiceFilterOptions>();
    @Output() dateOptions = new EventEmitter<InvoiceListPeriod>();
    @Output() godkendMarked = new EventEmitter();
    form: UntypedFormGroup;
    formSub$: Subscription;
    _filterOptions: InvoiceFilterOptions = {
        acontoOnly: false,
        godkendteOnly: null,
        la: undefined,
        ka: undefined,
        searchFor: ''
    };
    kaList$ = this.sessionSelector.users$(new Date()).pipe(map(users => users.filter(user => user.kundeansvarlig)));
    laList$ = this.sessionSelector.users$(new Date()).pipe(map(users => users.filter(user => user.ledelsesansvarlig)));
    get getGodkendtLabel() {
        switch (this._filterOptions.godkendteOnly) {
            case true: return 'Godkendte';
            case false: return 'Ikke godkendte';
            default: return 'Alle';
        }
    }

    constructor(
        private fb: UntypedFormBuilder,
        private sessionSelector: SessionSelectors
    ) {
        this.createForm();
    }

    ngOnInit(): void {
        const today = new Date();
        const startDate = `${today.getFullYear()}-01-01T00:00:00`;
        const untilDate = `${today.toISOString().slice(0, 10)}T00:00:00`;
        this.form.patchValue({startDate, untilDate});
        this.dateOptions.emit({startDate, untilDate});
        this.formSub$ = this.form.valueChanges.pipe(
            map(value => {
                if (!this.form.valid) { return; }
                this.dateOptions.emit(value);
            })
        ).subscribe();
        if (this.searchFor) {
            this.onSearch(this.searchFor);
        }
    }

    ngOnDestroy() {
        this.formSub$.unsubscribe();
    }

    createForm() {
        this.form = this.fb.group({
            startDate: ['', [Validators.required]],
            untilDate: ['', [Validators.required]]
        });
    }

    onSelectKA(user: IndexCard) {
        this._filterOptions.ka = user;
        this.emitFilter();
    }

    onSelectLA(user: IndexCard) {
        this._filterOptions.la = user;
        this.emitFilter();
    }

    onSearch(searchFor: string) {
        this._filterOptions.searchFor = searchFor;
        this.emitFilter();
    }

    onGodkendMarked() {
        this.godkendMarked.emit();
    }

    acontoToggle() {
        this._filterOptions.acontoOnly = !this._filterOptions.acontoOnly;
        this.emitFilter();
    }

    onGodkendte(godkendte: boolean) {
        this._filterOptions.godkendteOnly = godkendte;
        this.emitFilter();
    }

    private emitFilter() {
        this.filterOptions.emit({...this._filterOptions});
    }
}
